import {
  QUERY_LIST_SUCCESS,
  QUERY_DETAIL_SUCCESS,
  FETCH_START,
  FETCH_END,
} from '../../../actions/QueryField/QueryField/ActionTypes';

const initialState = {
  queryListData: {},
  queryDetailsData: {},
  loading: false,
};

const QueryFieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case QUERY_LIST_SUCCESS:
      return {
        ...state,
        queryListData: action.data,
      };
    case QUERY_DETAIL_SUCCESS:
      return {
        ...state,
        queryDetailsData: action.data,
      };
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default QueryFieldReducer;
